export default __webpack_public_path__ + "static/ti-28D-card-394b52f875b8fc24f86256e4789cf19c.jpg";